import*as React from"react";import{useStaticQuery,graphql}from"gatsby";import UserNavBar from"../UserComponents/NavBar";import{withPathPrefix}from"../../utils";async function loadRbacNavItems(a,b){try{return(await fetch(withPathPrefix("_auth/header",b))).json()}catch(b){return a}}export function NavBar(a){let{siteConfig:b,site:{pathPrefix:c}}=useStaticQuery(graphql`
      query NavQuery {
        ...NavFragment
        site {
          pathPrefix
        }
        siteConfig {
          withRbac
        }
      }
    `);const d=b.nav,e=b.withRbac,[f,g]=React.useState(d);return React.useEffect(()=>{e&&async function(){"development"===process.env.NODE_ENV||g(await loadRbacNavItems(f,c))}()},[e]),React.createElement(React.Fragment,null,React.createElement(UserNavBar,Object.assign({items:f,logo:b.logo,pathPrefix:c,sidebarName:a.sidebarName},a)))}